import {
  ILoyaltyPromotionInput,
  IPromotionInput,
  LoyaltyPromotionType,
  LoyaltySwapType,
} from '@fhs-legacy/frontend/src/generated/graphql-gateway';

import type { OfferCardProps } from '../components/offer-card/offer-card';
import { LoyaltyIncentiveOffer } from '../queries/loyalty.queries';

/** Prefer CMS / API `imageAlt`; fall back to title-based label when unset. */
export function offerImageAccessibilityLabel(title: string, imageAlt?: string | null): string {
  const trimmed = imageAlt?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : `${title} offer image`;
}

export const toLoyaltyPromotionInput = ({
  swap,
  type,
  ...rest
}: IPromotionInput): ILoyaltyPromotionInput => ({
  ...rest,
  type: type as string as LoyaltyPromotionType,
  ...(swap && {
    swap: {
      ...swap,
      type: swap.type as string as LoyaltySwapType,
    },
  }),
});

export function formatOfferCards(offers?: LoyaltyIncentiveOffer[], cardsToRender?: number) {
  return (
    offers?.slice(0, cardsToRender)?.map<OfferCardProps>(offer => ({
      id: offer.id,
      imageUrl: offer.image,
      imageAlt: offer.imageAlt,
      title: offer.name,
      description: offer.cardDescription,
      onPressButton: offer.isApplied ? offer.removeOffer : offer.applyOffer,
      onPressImage: offer.seeDetails,
      onPressTitle: offer.seeDetails,
      tag: offer.tag,
      buttonVariant: offer.isApplied ? 'applied' : 'default',
      buttonLabel: offer.isApplied
        ? 'Offer Applied'
        : offer.isAvailable
          ? 'Apply Offer'
          : 'See Details',
    })) ?? []
  );
}
